
import { defineComponent } from 'vue'
import BreedingManagerAdmin from '@/components/BreedingManagerAdmin.vue'
import CattleImport from '@/components/CattleImport.vue'
import UserImpersonation from '@/components/UserImpersonation.vue'

export default defineComponent({
  name: 'Setting',
  components: {
    BreedingManagerAdmin,
    CattleImport,
    UserImpersonation,
  },
})
